import { VersionCheckService } from '@23degrees/shared/services/version-check';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, input, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { MessageBus } from '@23degrees/shared/bus';
import { BaseClass } from '@23degrees/shared/classes/base.class';
import { TrackerService } from '@23degrees/shared/services/tracker/tracker.service';
import { REQUEST_MESSAGES, RESPONSE_MESSAGES } from '@config';

import { ContentManager } from '@23degrees/shared/manager/content/content.manager';
import { ContentSelector2Component } from '@23degrees/statistic/content-selector2';

@Component({
  selector: 'embed-page',
  templateUrl: 'embed-page.component.html',
  styleUrls: ['embed-page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ContentSelector2Component],
})
export default class EmbedPageComponent extends BaseClass implements OnInit {
  private cdr = inject(ChangeDetectorRef);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private messageBus = inject(MessageBus);
  private trackerService = inject(TrackerService);
  private versionCheckService = inject(VersionCheckService);
  private contentManager = inject(ContentManager);

  public slug = input.required<string>();
  public type = signal<string>(undefined);
  public options: any = {
    mode: 'embed',
    editor: false,
    public: true,
  };

  private baseUrl: string;
  constructor() {
    super();
    this.messageBus.on(RESPONSE_MESSAGES.ContentBySlug, 'embed', this.receiveContent, this.componentDestroyed$);
  }

  ngOnInit() {
    this.contentManager.setPublicFetch(true);

    const slug = this.route.snapshot.paramMap.get('slug');
    // console.log('[Embed2] ngOnInit slug:', slug);

    const message: Record<string, any> = { slug: slug, public: true };

    if (!this.isServer()) {
      try {
        const childSlug = this.route.snapshot.paramMap.get('child');
        const filterOptions = this.route.snapshot.paramMap.get('options');

        // check if filter is a childSlug
        if (filterOptions && !filterOptions.match(/\w{16}-/)) {
          let filterBase64 = filterOptions;
          if (filterBase64.length % 4 !== 0) {
            filterBase64 += '='.repeat(4 - (filterBase64.length % 4));
          }

          // https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding
          const filterStr = decodeURIComponent(atob(filterBase64));
          if (filterStr.startsWith('{') && filterStr.endsWith('}')) {
            const filterVisual = JSON.parse(filterStr);
            if (filterVisual.fieldName && filterVisual.filterValue) {
              message.filterVisual = filterVisual;
            } else {
              message.branchFilter = filterVisual;
            }

            this.router.navigate(
              ['embed', slug, childSlug].filter((param) => !!param),
              { replaceUrl: true, queryParams: { filter: filterOptions } },
            );
          }
        }
      } catch (error) {
        console.log('[Embed2] Error during options parsing:', error);
      }
    }

    // console.log('[Embed2] ngOnInit emit slug:', slug, message);

    this.messageBus.emit(REQUEST_MESSAGES.ContentBySlug, ['embed'], message);

    this.trackerService.postMessage({ action: 'appReady', contentSlug: slug });
  }

  // ngOnDestroy() {
    // console.log('[Embed2] ngOnDestroy');
    // console.trace();
  // }

  public receiveContent = (msg) => {
    const { content } = msg;

    this.type.set(content.type);
    // this.slug = content.slug;

    this.globalService.updateMetaInfo(content, true);
    this.versionCheckService.check(this.slug());

    if (content.vUserInfo?.noTracking !== true) {
      // this.analyticsService.setupGA();
    }

    // this.cdr.detectChanges();
  };

  //   public sendAction = (action) => {
  //     if (!this.isServer) {
  //       try {
  //         if (window && window.parent) {
  //           window.parent.postMessage({ action }, '*');
  //         }
  //       } catch (error) {
  //         console.log('PostMessage blocked');
  //       }
  //     }
  //   };
}
